import React from "react";
import "./CookiesPolicy.css";

const CookiesPolicy = () => {
    return (
        <div className="cookies-policy-container" translate="no">
            <h1>Política de Cookies</h1>
            <p>
                Las cookies son pequeños archivos de texto que se almacenan en su navegador cuando visita un sitio web. 
                Su función principal es recordar información sobre su visita para mejorar la experiencia del usuario. 
                Estas pueden almacenar preferencias, datos de sesión, estadísticas de uso y enlaces a redes sociales.
            </p>
            <h2>Cookies utilizadas en este sitio web</h2>
            <p>
                Siguiendo las normativas de privacidad, detallamos el uso de cookies en esta web:
            </p>
            <h3>Cookies propias:</h3>
            <ul>
                <li>Cookies de sesión: Garantizan que los usuarios que comentan en el blog sean humanos y no bots.</li>
            </ul>
            <h3>Cookies de terceros:</h3>
            <ul>
                <li><strong>Google Analytics:</strong> Almacena datos sobre el tráfico web para analizar el uso del sitio.</li>
                <li><strong>Redes sociales:</strong> Cada plataforma utiliza sus propias cookies para compartir contenido.</li>
            </ul>
            <h2>Desactivación o eliminación de cookies</h2>
            <p>
                Puede gestionar sus cookies a través de la configuración de su navegador. A continuación, le proporcionamos enlaces 
                a las guías de los navegadores más utilizados:
            </p>
            <ul>
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
                <li><a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noopener noreferrer">Internet Explorer</a></li>
                <li><a href="https://support.apple.com/es-es/HT201265" target="_blank" rel="noopener noreferrer">Safari</a></li>
            </ul>
            <h2>Notas adicionales</h2>
            <p>
                No nos hacemos responsables del contenido o veracidad de las políticas de privacidad de terceros mencionados en esta página. 
                Para cualquier consulta, puede ponerse en contacto con nosotros a través de la sección de contacto de la web.
            </p>
        </div>
    );
};

export default CookiesPolicy;
